// extracted by mini-css-extract-plugin
export default {"openButton":"BJhbxG6U"};